<template>
  <div>
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" class="w-100" />
      <el-row v-else key="content-loading">
        <el-button-group class="attendee-actions-section-btn-grp">
          <el-button :type="activeTab == 1 ? 'primary' : ''" size="small" icon="el-icon-s-promotion" @click="activeTab = 1">
            {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.messages") }}
          </el-button>
          <el-button :type="activeTab == 2 ? 'primary' : ''" size="small" icon="fas fa-map-marker-alt" @click="activeTab = 2">
            {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.checkin") }}
          </el-button>
          <el-button :type="activeTab == 3 ? 'primary' : ''" size="small" icon="el-icon-printer" @click="activeTab = 3">
            {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.cardPrinting") }}
          </el-button>
          <el-button :type="activeTab == 4 ? 'primary' : ''" size="small" icon="el-icon-medal" @click="activeTab = 4">
            {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.certificates") }}
          </el-button>
          <el-button :type="activeTab == 5 ? 'primary' : ''" size="small" icon="el-icon-present" @click="activeTab = 5">
            {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.promotion") }}
          </el-button>
        </el-button-group>

        <div class="attendee-actions-section" v-if="activeTab == 1">
          <template v-if="participant.automatedMessageLogs.length > 0">
            <div class="actions-item" v-for="voucher in this.participant.automatedMessageLogs" :key="voucher.id">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.title") }}</span>
              <span>
                <strong>{{ voucher.voucherTitle }}</strong>
                {{ getEnumsDisplay("AutomatedMessageType", voucher.type) }}
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.status") }}</span>
              <span>
                <b>{{ getEnumsDisplay("AutomatedMessageLogStatus", voucher.status) }}</b>
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>{{ $moment(voucher.createDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}</b>
                <span>- {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.dateByWho", [voucher.senderUser != null ? voucher.senderUser.fullName + " " + voucher.senderUser.lastName : $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.system")]) }}</span>
              </span>
              <!-- - {{ voucher.senderUser != null ? voucher.senderUser.fullName + ' ' + voucher.senderUser.lastName : $t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.system') }} tarafından gerçekleştirildi. -->
              <!-- <div class="attendee-actions-edit">
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.view')" placement="top-start">
                  <el-button size="small" icon="fas fa-search" circle></el-button>
                </el-tooltip>
              </div> -->
            </div>
          </template>
          <el-alert type="info" v-else :show-icon="true" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.noVouchers')"></el-alert>
          <!-- <div class="actions-item">
        <span>Başlık</span>
        <span>
          <strong>Etkinlik alanına gelmeden önce...</strong>
          - E-posta ile
        </span>
        <span>Durum</span>
        <span><b>İletildi</b></span>
        <span>Kayıt tarihi</span>
        <span>
          <b>11 May 2022, 17:07</b>
          - Özkan T. tarafından gerçekleştirildi.
        </span>
        <div class="attendee-actions-edit">
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.view')" placement="top-start">
            <el-button size="small" icon="fas fa-search" circle></el-button>
          </el-tooltip>
        </div>
      </div> -->
        </div>

        <div class="attendee-actions-section" v-if="activeTab == 2">
          <template v-if="participant.checkIns.length > 0">
            <div class="actions-item" v-for="checkIn in participant.checkIns" :key="checkIn.id">
              <template v-if="checkIn.type != null">
                <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.description") }}</span>
                <span>
                  <b>{{ getEnumsDisplay("CheckInType", checkIn.type) }}</b>
                </span>
              </template>

              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>
                  {{ $moment(checkIn.checkInDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}
                </b>
                <span v-if="checkIn.owner != null" v-html="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.dateByWho', [checkIn.owner.firstName + ' ' + checkIn.owner.lastName])"></span>
              </span>
            </div>
          </template>
          <template v-if="participant.standCheckIns.length > 0">
            <div class="actions-item" v-for="standCheckIn in participant.standCheckIns" :key="standCheckIn.id">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.description") }}</span>
              <span>
                <b>{{ getEnumsDisplay("StandCheckInType", standCheckIn.type) }}</b>
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>
                  {{ $moment(standCheckIn.checkInDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}
                </b>
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.standName") }}</span>
              <span v-if="standCheckIn.stand">
                <b>{{ standCheckIn.stand.title }}</b>
              </span>
            </div>
          </template>
          <el-alert v-if="participant.checkIns.length == 0 && participant.standCheckIns.length == 0" type="info" :closable="false" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.noCheckinRegistration')" :show-icon="true"></el-alert>
          <!-- <div class="actions-item">
        <span>Açıklama</span>
        <span><b>Manuel check-in</b></span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b> - Özkan T. tarafından gerçekleştirildi.</span>
      </div>
      <div class="actions-item">
        <span>Açıklama</span>
        <span><b>Dijital check-in</b></span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b> - Sistem tarafından gerçekleştirildi.</span>
      </div> -->
        </div>

        <div class="attendee-actions-section" v-if="activeTab == 3">
          <template v-if="participant.cardPrints.length > 0">
            <div class="actions-item" v-for="print in participant.cardPrints" :key="print.id">
              <span v-if="print.printSchemeTitle != null">{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.card") }}</span>
              <span v-if="print.printSchemeTitle != null">
                <strong>{{ print.printSchemeTitle }}</strong>
              </span>
              <span v-if="print.reason != null">{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.description") }}</span>
              <span v-if="print.reason != null">
                <b>{{ print.reason }}</b>
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>{{ $moment(print.printDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}</b>
                - {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.dateByWho", [print.owner.firstName + " " + print.owner.lastName]) }}
              </span>
            </div>
          </template>
          <el-alert type="info" :closable="false" v-else :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.noCards')" :show-icon="true"></el-alert>
          <!-- <div class="actions-item">
        <span>Kart</span>
        <span><strong>Katılımcı kartı</strong></span>
        <span>Açıklama</span>
        <span><b>-</b></span>
        <span>Kayıt tarihi</span>
        <span><b>11 May 2022, 17:07</b> - Özkan T. tarafından gerçekleştirildi.</span>
      </div> -->
        </div>

        <div class="attendee-actions-section" v-if="activeTab == 4">
          <template v-if="participant.certificates.length > 0">
            <div class="actions-item" v-for="certificate in participant.certificates" :key="certificate.id">
              <span v-if="schemes.find(x => x.id == certificate.certificateSchemeID) != null">{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.certificate") }}</span>
              <span v-if="schemes.find(x => x.id == certificate.certificateSchemeID) != null">
                <strong>{{ schemes.find(x => x.id == certificate.certificateSchemeID).title }}</strong>
              </span>
              <span>ID</span>
              <span>
                <b>#{{ certificate.certificateNO }}</b>
              </span>

              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>
                  {{ $moment(certificate.sendDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}
                </b>
                <span v-if="certificate.owner != null">- {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.dateByWho", [certificate.owner.firstName + " " + certificate.owner.lastName]) }}</span>
              </span>
              <div class="attendee-actions-edit">
                <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.show')" placement="top-start">
                  <el-button size="small" icon="fas fa-search" circle @click="goUrl(certificate.certificateNO)"></el-button>
                </el-tooltip>
              </div>
            </div>
          </template>
          <el-alert v-else type="info" :show-icon="true" :closable="false" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.noCertifacete')"></el-alert>
        </div>

        <div class="attendee-actions-section" v-if="activeTab == 5">
          <template v-if="participant.promotionReceives.length > 0">
            <div class="actions-item" v-for="promotion in participant.promotionReceives" :key="promotion.id">
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.promotion") }}</span>
              <span>
                <strong>{{ getPromotion(promotion.promotionID).title }}</strong>
                {{ promotion.count }} {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.piece") }}
              </span>
              <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeeActions.registrationDate") }}</span>
              <span>
                <b>{{ $moment(promotion.createDate).format("DD MMMM YYYY, ddd HH:mm:ss") }}</b>
              </span>
            </div>
          </template>
          <el-alert v-else type="info" :show-icon="true" :closable="false" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeActions.noPromotion')"></el-alert>
        </div>
      </el-row>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["participant", "certschemes"],
  data() {
    return {
      vouchers: [],
      activeTab: 1,
      filter: {
        skip: 0,
        take: 1000,
        participantNo: null,
        participantId: this.participant.id,
        ids: [],
        total: 0,
        page: 1,
        status: null,
        automatedMessageId: null,
        automatedMessageIds: []
      },

      schemes: [],
      vouchers: [],
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getPromotions");
      if (this.certschemes != null && this.certschemes != undefined) {
        this.schemes = this.certschemes;
      }
      // await this.getVouchers();
      this.loading = false;
    }, 500);
  },
  methods: {
    async getVouchers() {
      var res = await this.$store.dispatch("getAutomatedMessageLogs", this.filter);
      if (!res.data.alert.hasError) {
        this.vouchers = res.data.data.items;
        this.filter.total = res.data.data.totalCount;
      }
    },
    goUrl(no) {
      window.open("https://register.holacon.com/certificate/" + no, "_blank");
    },
    getPromotion(id) {
      var promotion = this.$store.state.promotions.items.find(x => x.id == id);
      if (promotion != null) {
        return promotion;
      } else {
        return null;
      }
    }
    // async getVouchers() {
    //   var res = await this.$store.dispatch("getAutomatedMessageLogs", this.filter);
    //   if (!res.data.alert.hasError) {
    //     this.vouchers = res.data.data.items;
    //     this.filter.total = res.data.data.totalCount;
    //   }
    // }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeActions.vue